<div class="context-view" [class.stations-mode]="isStationsMode()">
  <dx-data-grid
    id="assignment-grid-search"
    [dataSource]="searchAssignments()"
    [showRowLines]="true"
    [showColumnLines]="false"
    [showBorders]="true"
    [keyExpr]="['AssignmentNo', 'Type']"
    [noDataText]="'ASSIGNMENT.NOSEARCHRESULTS' | translate"
    (onRowDblClick)="loadAssignment($event)"
    (onRowPrepared)="onRowPrepared($event)"
    (onRowExpanded)="loadAssignmentSubtableData($event)"
    (onSelectionChanged)="updateSelectionOrder($event)">
    @if (!isStationsMode()) {
      <dxo-toolbar>
        <dxi-item location="before" template="serverSearch"></dxi-item>
      </dxo-toolbar>

      <div *dxTemplate="let _ of 'serverSearch'" class="action-list">
        <div class="action-search">
          <dx-text-box
            mode="search"
            [showClearButton]="true"
            valueChangeEvent="input"
            (onValueChanged)="onSearchTextChanged($event.value)"
            [placeholder]="'ASSIGNMENT.SEARCHPLACEHOLDER' | translate"></dx-text-box>
        </div>

        <div class="action-checkbox">
          <dx-check-box
            class="ml-2"
            text="{{ 'ASSIGNMENT.FILTER_BY_DATE' | translate }}"
            [value]="filterByDate()"
            (onValueChanged)="onFilterByDateChanged($event.value)">
          </dx-check-box>
          @if (filterByDate()) {
            <ng-container>
              <dx-date-box
                class="ml-2"
                type="date"
                displayFormat="dd.MM.yyyy"
                [value]="filterDate()"
                (onValueChanged)="onFilterDateChanged($event.value)"
                [placeholder]="'ASSIGNMENT.SELECT_DATE' | translate">
              </dx-date-box>
            </ng-container>
          }
        </div>
      </div>
    }
    <dxo-selection mode="multiple" showCheckBoxesMode="none" selectAllMode="page"></dxo-selection>
    <dxo-master-detail [enabled]="true" [autoExpandAll]="false" [template]="'detail'"> </dxo-master-detail>

    <!-- MASTER -->
    <dxi-column
      dataField="Type"
      [width]="60"
      [caption]="'ASSIGNMENT.TYPE' | translate"
      alignment="center"
      cellTemplate="cellTemplate"
      [allowSorting]="false"></dxi-column>

    <div *dxTemplate="let data of 'cellTemplate'">
      <app-icon [kind]="data.text"></app-icon>
    </div>

    @if (isStationsMode()) {
      <dxi-column
        [width]="70"
        [caption]="'ASSIGNMENT.STATE.PLANNED' | translate"
        alignment="center"
        cellTemplate="plStationStatusTemplate"
        [allowSorting]="false"></dxi-column>
      <div *dxTemplate="let cell of 'plStationStatusTemplate'" class="pl-station-status-cell">
        <span
          [title]="(isPlannedStation(cell.data) ? 'ASSIGNMENT.STATE.PLANNED' : 'ASSIGNMENT.STATE.OPEN') | translate">
          @if (isPlannedStation(cell.data)) {
            ✓
          } @else {
            ○
          }
        </span>
      </div>
    }

    <dxi-column
      dataField="AssignmentNo"
      [width]="80"
      [caption]="'ASSIGNMENT.ASSIGNMENTNO' | translate"
      [allowSorting]="false"
      [calculateCellValue]="utilService.asString"></dxi-column>

    <dxi-column
      dataField="Statustext"
      [width]="60"
      [caption]="'ASSIGNMENT.STATUSTEXT' | translate"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      dataField="MIAuftrag"
      [width]="60"
      [caption]="'ASSIGNMENT.INFO' | translate"
      alignment="left"
      cellTemplate="cellTemplateMI"
      cssClass="badge-cell"
      [allowSorting]="false"></dxi-column>

    <div *dxTemplate="let data of 'cellTemplateMI'" class="mi">
      <app-assignment-info-badges [assignment]="data.data" />
    </div>

    <dxi-column
      dataField="EventDate"
      [width]="90"
      [caption]="'ASSIGNMENT.ACTIONDATE' | translate"
      format="EE dd.MM.yy"
      dataType="date"
      [allowSorting]="false"
      cssClass="bold"></dxi-column>

    <dxi-column
      dataField="EventTime"
      [width]="80"
      [caption]="'ASSIGNMENT.ACTIONTIME' | translate"
      dataType="time"
      [allowSorting]="false"
      cssClass="bold"></dxi-column>

    <dxi-column
      [width]="40"
      dataField="T1"
      [caption]="'ASSIGNMENT.T1' | translate"
      alignment="center"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      [width]="40"
      dataField="T2"
      [caption]="'ASSIGNMENT.T2' | translate"
      alignment="center"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      dataField="DispoDateFrom"
      [width]="80"
      [caption]="'ASSIGNMENT.DISPOVON' | translate"
      format="dd.MM.yy"
      dataType="date"
      [visible]="!isStationsMode()"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      dataField="DispoDateTo"
      [width]="80"
      [caption]="'ASSIGNMENT.DISPOBIS' | translate"
      format="dd.MM.yy"
      dataType="date"
      [visible]="!isStationsMode()"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      dataField="EventAddress"
      [minWidth]="120"
      [caption]="'ASSIGNMENT.EVENTADDRESS' | translate"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      dataField="EventStreet"
      [minWidth]="80"
      [caption]="'ASSIGNMENT.EVENTSTREET' | translate"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      dataField="EventCountry"
      [width]="40"
      [caption]="'ASSIGNMENT.EVENTCOUNTRY' | translate"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      dataField="EventZipCode"
      [width]="60"
      [caption]="'ASSIGNMENT.EVENTZIPCODE' | translate"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      dataField="EventCity"
      [minWidth]="80"
      [caption]="'ASSIGNMENT.EVENTCITY' | translate"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      dataField="EffectiveVolume"
      [width]="65"
      [caption]="'ASSIGNMENT.VOLUME' | translate"
      [visible]="!isStationsMode()"
      [allowSorting]="false">
      <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
    </dxi-column>

    <dxi-column
      dataField="EffectiveWeight"
      [width]="65"
      [caption]="'ASSIGNMENT.WEIGHT' | translate"
      [visible]="!isStationsMode()"
      [allowSorting]="false">
      <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
    </dxi-column>

    <dxi-column
      dataField="StationDispoVolume"
      [width]="65"
      [caption]="'ASSIGNMENT.SUBTABLE.DISPOVOLUMEN' | translate"
      [visible]="isStationsMode()"
      [allowSorting]="false">
      <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
    </dxi-column>

    <dxi-column
      dataField="StationDispoWeight"
      [width]="65"
      [caption]="'ASSIGNMENT.SUBTABLE.DISPOGEWICHT' | translate"
      [visible]="isStationsMode()"
      [allowSorting]="false">
      <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
    </dxi-column>

    <dxi-column
      dataField="RemainingDispoVol"
      [width]="65"
      [caption]="'ASSIGNMENT.DISPOVOLUME' | translate"
      [allowSorting]="false">
      <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
    </dxi-column>

    <dxi-column
      dataField="RemainingDispoWeight"
      [width]="65"
      [caption]="'ASSIGNMENT.DISPOWEIGHT' | translate"
      [allowSorting]="false">
      <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
    </dxi-column>

    <dxi-column
      dataField="Sachbearbeiter"
      [minWidth]="80"
      [caption]="'ASSIGNMENT.SACHBEARBEITER' | translate"
      [visible]="!isStationsMode()"
      [allowSorting]="false"></dxi-column>

    <!-- DETAIL -->
    <div *dxTemplate="let item of 'detail'">
      @if (!item.data.subtableData) {
        <dx-load-indicator class="large-indicator"></dx-load-indicator>
      } @else {
        <div class="row inner-detail-table">
          <div class="col">
            <div class="dx-field">
              <div class="header">{{ 'SHARED.GENERAL' | translate }}</div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.STATUS' | translate }}:</div>
                <div class="value-static">{{ item.data.subtableData.Status }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.TRANSPORTSTATUS' | translate }}:</div>
                <div class="value-static">{{ item.data.subtableData.TransportStatus }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.PRODNAME' | translate }}:</div>
                <div class="value-static">{{ item.data.subtableData.ProdName }}</div>
              </div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.AKTIONSTEXT' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.AktionsText }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.KONTAKT' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.Kontakt }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.TRAPO_PROJECTS_ASSIGNED_TO' | translate }}:</div>
                <div class="static">{{ item.data.TrapoProjectsAssignedTo }}</div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="dx-field">
              <div class="header">{{ 'SHARED.WEIGHT_VOLUME' | translate }}</div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.AUSGGEWICHT_LONG' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.AusgGewicht | number: '1.2-2' }} t</div>
              </div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.AUSGABEVOLUMEN_LONG' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.AusgabeVolumen | number: '1.2-2' }} m³</div>
              </div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.DISPOGEWICHT_LONG' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.DispoGewicht | number: '1.2-2' }} t</div>
              </div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.DISPOVOLUMEN_LONG' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.DispoVolumen | number: '1.2-2' }} m³</div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="dx-field">
              <div class="header">{{ 'SHARED.ETC' | translate }}</div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.MIETKAUF' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.MieteKauf }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.ENTFERNUNGKM' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.EntfernungKm ?? 0 }} km</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.MEMO' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.Memo }}</div>
              </div>

              @if (item.data.Type === AssignmentType.AssignmentDelivery) {
                <div class="field-set">
                  <div class="label">{{ 'ASSIGNMENT.SUBTABLE.MIAUFTRAG' | translate }}:</div>
                  <div class="static">
                    {{ 'ASSIGNMENT.SUBTABLE.MIAUFTRAGSTATUS.' + item.data.subtableData.MIAuftrag | translate }}
                  </div>
                </div>
              }

              @if (item.data.subtableData.Type === AssignmentType.AssignmentPickup) {
                <div class="field-set">
                  <div class="label">{{ 'ASSIGNMENT.SUBTABLE.NUMMIPROBSOLUTIONS' | translate }}:</div>
                  <div class="static">{{ item.data.subtableData.NumMIProbSolutions }}</div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </dx-data-grid>

  <app-loader [hide]="!isSearchLoading()"></app-loader>
</div>
